import React from 'react';
import { ProcessHype, ProcessSteps, SEO } from '../../components';
import { graphql } from 'gatsby';
import './process.css';

function ProcessPage() {
  return (
    <main id='process-page'>
      <ProcessHype />
      <ProcessSteps />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`How Laser Hair Removal Works | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Click here to see how Milan laser hair removal works, what you can expect during your visit, and some pre and post treatment considerations.'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default ProcessPage;
